import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Allergy, family_history, medicalHistoryApiData, medicalHistoryOthersData, medicalHistoryUiEdit, Medication, SocialHistory, SocialHistory_Alcohol, Social_History_Data, SocialHistory_Smoking, pastMedicalHitory_item } from '../models/history';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
    providedIn: 'root'
})
export class MedicalHistoryService {

    constructor(
        private utilitiesService: UtilitiesService,
        private readonly sanitizer: DomSanitizer
    ) { }


    shallow_copy(a) {
        return this.utilitiesService.shallow_copy(a);
    }

    init_medicalHistoryApiData(): medicalHistoryApiData {
        let a: medicalHistoryApiData = new medicalHistoryApiData();
        a = {
            currentMedicalProblems: "",
            past_medical_history_data: [],
            selected_past_medical_history_data: [],
            past_surgical_history_data: "",
            medications: [],
            allergies: [],
            social_history: {
                alcohol: this.init_Alcohol(),
                smoking: this.init_Smoking(),
            },
            selected_family_history: [],
            family_history: [
                { name: 'Mother', data: [] },
                { name: 'Father', data: [] },
                { name: 'Brother', data: [] },
                { name: 'Sister', data: [] }
            ],
            other_data: this.init_medicalHistoryOthersData(),
        };
        return a;
    }

    init_medicalHistoryOthersData(): medicalHistoryOthersData {
        let a: medicalHistoryOthersData
        a = {
            is_exist_current_medical_problem: false,
            is_exist_past_surgical_history: false,
            empty_medical_history: false,
            family_history_options_data: [],
            none_selected_medical_history: false
        }
        return a;

    }

    init_medicalHistoryUiEdit(): medicalHistoryUiEdit {
        let a: medicalHistoryUiEdit = new medicalHistoryUiEdit();
        a = {
            others: {
                data: this.init_medicalHistoryApiData(),
                more_medical: false,
                medical_history_value: "",
                none_selected_medical_history: false,
                medical_history_row: [],
                add_temp_medication: this.init_Medication(),
                edit_temp_medication: this.init_Medication(),
                medication_edit_id: -1,
                medication_columns: [],
                add_temp_allergy: this.init_Allergy(),
                edit_temp_allergy: this.init_Allergy(),
                allergy_edit_id: -1,
                allergy_columns: [],
                delete_header_name: "",
                years: [],
                year: new Date().getFullYear(),
            },
            api_data: this.init_medicalHistoryApiData(),
        }
        return a;
    }

    init_Medication(): Medication {
        let a: Medication = new Medication();
        a = {
            id: -1,
            name: "",
            dose: "",
            times_per_day: "",
            instructions: "",
        }
        return a;
    }

    init_Alcohol(): SocialHistory_Alcohol {
        let a: SocialHistory_Alcohol = new SocialHistory_Alcohol();
        a = {
            data: { year_of_quitting: null, drinks_per_week: "" },
            selected: "",
        }
        return a;
    }

    init_Smoking(): SocialHistory_Smoking {
        let a: SocialHistory_Smoking = new SocialHistory_Smoking();
        a = {
            data: { number_of_packs_per_day: "", numbers_of_years_smoked: "", year_of_quitting: null },
            selected: "",
        }
        return a;
    }

    init_Allergy(): Allergy {
        let a: Allergy = new Allergy();
        a = {
            id: -1,
            name: "",
            reaction: "",
        }
        return a;
    }


    preprocess_familyhistory(raw_familyhistory: family_history[]): family_history[] {
        let a: family_history[] = this.init_medicalHistoryApiData().family_history;
        a = a.map((e) => {
            let e_new = this.shallow_copy(e);
            let find_result = raw_familyhistory.find((ele) => (ele["name"] == e["name"]))
            Boolean(find_result) ? e_new["data"] = find_result["data"] : [];
            return e_new;
        });
        return a;
    }

    preprocess_socialhistory(socialHistory: SocialHistory): Social_History_Data {
        let smoking: SocialHistory_Smoking, alcohol: SocialHistory_Alcohol;
        smoking = this.init_Smoking();
        alcohol = this.init_Alcohol();
        this.utilitiesService.copy_json(smoking, socialHistory.smoking);
        this.utilitiesService.copy_json(alcohol, socialHistory.alcohol);
        let socialHistory_data = "";
        if (socialHistory.smoking.selected == 'Yes') {
            socialHistory_data +=
                'Smoking :' +
                smoking.selected +
                '\n' +
                ' Number of Packs :' +
                smoking.data.number_of_packs_per_day +
                '\n Number of Years :' +
                smoking.data.numbers_of_years_smoked +
                '\n';
        } else if (socialHistory.smoking.selected == 'Not Currently') {
            socialHistory_data +=
                'Smoking :' +
                smoking.selected +
                '\n' +
                ' Year of Quitting :' +
                socialHistory.smoking.data.year_of_quitting +
                '\n';
        } else if (socialHistory.smoking.selected == 'Never') {
            socialHistory_data +=
                'Smoking :' + socialHistory.smoking.selected + '\n';
        }
        socialHistory_data += '\n';
        if (socialHistory.alcohol.selected == 'Yes') {
            socialHistory_data +=
                'Alcohol :' +
                socialHistory.alcohol.selected +
                ' \n Drinks per week :' +
                socialHistory.alcohol.data.drinks_per_week +
                '\n';
        } else if (socialHistory.alcohol.selected == 'Not Currently') {
            socialHistory_data +=
                'Alcohol :' +
                socialHistory.alcohol.selected +
                '\n Year of Quitting :' +
                socialHistory.alcohol.data.year_of_quitting +
                '\n';
        } else if (socialHistory.alcohol.selected == 'Never') {
            socialHistory_data +=
                'Alcohol :' + socialHistory.alcohol.selected + '\n';
        }

        let social_history_data: Social_History_Data = {
            social_history_data: this.sanitizer.bypassSecurityTrustHtml(socialHistory_data),
            smoking: smoking,
            alcohol: alcohol,
        }

        return social_history_data;
    }

    preprocess_medicalhistory(default_history_list: pastMedicalHitory_item[], selected_history_list: pastMedicalHitory_item[]): pastMedicalHitory_item[] {
        let final_history_list: pastMedicalHitory_item[]
        let j = 0;
        final_history_list = default_history_list.map((e) => {
            let e_new: pastMedicalHitory_item = this.shallow_copy(e);
            let find_result = selected_history_list.find((ele) => ele["id"] == e["id"]);
            // let find_result = selected_history_list.find((ele) => ele["id"] == e["id"]);
            e_new["selected"] = Boolean(find_result) ? true : false;
            Boolean(find_result) ? j++ : 0;
            return e_new;
        })

        while (j < selected_history_list.length) {
            final_history_list.push({
                id: final_history_list.length + 1,
                name: selected_history_list[j].name,
                selected: true
            })
            j++;
        }
        return final_history_list;
    }


    allMedicalSelectdCheck(default_history_list: pastMedicalHitory_item[]): boolean {
        let empty_medical_history: boolean = true;
        let a: pastMedicalHitory_item[] = default_history_list.filter((e) => e.selected);
        if (a.length > 0) {
            empty_medical_history = false;
        }
        return empty_medical_history;
    }

    filterMedicalHistory(data: pastMedicalHitory_item[]): pastMedicalHitory_item[] {
        let a: pastMedicalHitory_item[] = [];
        a = data.map((e) => {
            let e_new: pastMedicalHitory_item = this.shallow_copy(e);
            e_new.id = e.id;
            return e_new;
        }).filter((e) => e.selected);
        return a;
    }

    filterFamilyHistory(data: family_history[]): family_history[] {
        let a: family_history[] = [];
        a = data.filter((e) => e.data.length > 0);
        return a;
    }

}
